import { React, useState, useEffect } from 'react'
import { language } from '../../stores/slices/languageSlice'
import { useSelector, useDispatch } from 'react-redux'
import Input from '../input/Input'
import { useNavigate } from 'react-router-dom'
import validateInput from '../../utilities/validations/validateInput';
import { toast } from "react-toastify";
import { Mail, Phone, Home } from 'react-feather';
import { getPatientDetails, getSearchPatientByProgram, setGetMemberLookupData, setGetPartnerMemberLookupData, getPatientMemberInPartner, setRouteToPrescreen, getFatchPhoneNumber, IsPatientLockedReset, setAllowCaseCreation } from '../../stores/slices/patientSearch/patientSearchSlice';
import { Modal, Switch } from 'antd';
import { CASE_CP_REDIRECTION_URL, isLoader } from "../../constant/Constants";
import { setConditionalRoute } from '../../stores/slices/generalConfiguration/routeRestrictionSlice';
import { setProgramSpecificLookUp } from "../../stores/slices/lookupSlice"
import { patientApplication } from '../../stores/slices/patientSearch/patientApplicationListSlice'
import maskData from '../../utilities/validations/maskData'
import { getAllSessions } from '../../utilities/API/supertokenServices'
import { getMemberDetails } from '../../stores/slices/appViewDetailsSlice'
import { generateHashData } from '../../stores/slices/caseManagement/generateHashDataSlice'
import { updateEmailAPI } from '../../stores/slices/portalUserEmailUpdate/portalUserEmailUpdateSlice'


function PatientDetails({ value }) {

    const dispatch = useDispatch();
    const navigate = useNavigate();

    // language & content from the store
    const selectedLanguage = useSelector(language).PatientSearch.patientDetails;
    const errorMessage = useSelector(language).errorMessage;
    const generalConfig = useSelector((state) => state.generalConfigSlice);
    const searchPatient = useSelector((state) => state.patientSearchSlice);
    const loginData = useSelector((state) => state.loginSlice)
    const sessionData = useSelector((state) => state.sessionSlice)
    const patientCaseListData = useSelector((state) => state.patientCaseListSlice)
    const createPatientLanguage = useSelector(language).PatientSearch.createPatient;

    // Initial state for select program
    const [selectProgram, setSelectProgram] = useState({
        program: {
            value: '',
            isValid: true,
        }
    });

    const [emailModal, setEmailModal] = useState(false);
    const [updateEmail, setUpdateEmail] = useState({
        email: {
            value: "",
            isValid: true,
        },
    })
    const [allowedEmailDomains, setAllowedEmailDomains] = useState([])
    const [failureSFMsg, setFailureSFMsgs] = useState([])


    // Input onChange validation
    const inputOnChange = (e, feildValidation) => {

        let inputValue = e.target.value;
        let inputName = e.target.name;
        // Updating the onChange input values to the respective state
        setSelectProgram((prevState) => ({
            ...prevState,
            [inputName]: {
                value: inputValue,
                isValid: true
            }
        }))
    }

    const emailOnChange = (e, fieldValidation) => {

    let inputValue = e.target.value;
    let inputName = e.target.name;

    let inputValidate = validateInput(inputValue, fieldValidation);
    setUpdateEmail((prevState) => ({
      ...prevState,
      [inputName]: {
        value: inputValidate.value,
        isValid: inputValidate.isValid
      }
    }))

  }

    useEffect(() => {
        dispatch(getFatchPhoneNumber())
        setSelectProgram({
            program: {
                value: '',
                isValid: true,
            }
        })
        setUpdateEmail({
          email: {
            value: loginData.Email,
            isValid: true,
          },
        });
    }, [])

    // onClick Create Application / Case
    const onCreateApp = async () => {
        if (selectProgram.program.value != '') {
            if (selectProgram.program.value == "CM") {
                if (!searchPatient.allowCaseCreation) { toast.error("This patient was initiated the case. To create a new case, click the Search button.") } else {
                    dispatch(setAllowCaseCreation(false))
                    const hashed = await dispatch(generateHashData({ portalUserId: loginData.value.PortalUserID, patienId: searchPatient.patientDetails.patientId }))
                    if (hashed?.payload?.HashDetails?.HashValue) {
                        const hashData = hashed?.payload?.HashDetails?.HashValue
                        window.open(`${CASE_CP_REDIRECTION_URL}?token=${hashData}`, '_blank');
                    } else {
                        if (hashed?.payload?.ResponseDetails?.ResponseCode == "RE006" && hashed?.payload?.ResponseDetails?.AllowedEmailDomains && JSON.parse(hashed?.payload?.ResponseDetails?.AllowedEmailDomains?.length > 0)) {
                            setAllowedEmailDomains(JSON.parse(hashed?.payload?.ResponseDetails?.AllowedEmailDomains))
                            setFailureSFMsgs(hashed?.payload?.ResponseDetails?.message)
                            setEmailModal(true)
                        } else {
                            toast.error("Something went wrong, Please try again in a few minutes");
                        }
                    }
                }
            } else {
                if ((selectProgram.program.value == 'CPR' && searchPatient.patientDetails.patientIdCPR != '') || (selectProgram.program.value == 'FAF' && searchPatient.patientDetails.patientIdFAF != '')) {
                    //patient search reg program

                //member page
                let id = ''
                if (selectProgram.program.value == 'CPR') {
                    id = searchPatient.patientDetails.patientIdCPR;
                } else if (selectProgram.program.value == 'FAF') {
                    id = searchPatient.patientDetails.patientIdFAF;
                } else {
                    id = searchPatient.patientDetails.patientIdCASE;
                }
                dispatch(getMemberDetails({ memberId: id, prgData: selectProgram.program.value }))

            } else {
                let reqBody = {
                    Patients: {
                        FirstName: searchPatient.patientDetails.firstName.trim(),
                        LastName: searchPatient.patientDetails.lastName.trim(),
                        DateOfBirth: searchPatient.patientDetails.dob.trim(),
                        SocialSecurityNumber: searchPatient.patientDetails.ssn.trim(),
                        AlienNumber: searchPatient.patientDetails.alienNumber.trim(),
                    },
                    Provider: {
                        ProviderID: `E-${loginData.value.EIN}`,
                        ProviderNPINbr: `E-${loginData.value.EIN}`,
                        IsPortalAuthorized: "true",
                        IsPaymentAuthorized: "true",
                        IsAuthorizedProvider: "true"
                    }

                }
                dispatch(getSearchPatientByProgram({ data: reqBody, prgData: selectProgram.program.value, patientPartnerID: searchPatient.patientDetails.patientId }))

            }
        }
        } else {
            setSelectProgram((prevState) => ({
                ...prevState,
                program: {
                    value: selectProgram.program.value,
                    isValid: selectProgram.program.value != '' && selectProgram.program.isValid ? true : false,
                }
            }))
            toast.error(errorMessage.mandatoryFieldsToastErrorMessage)
        }
    }

    // Get Program specific data if the patient exist on the program specific patient search
    const getMemberDataOfPatient = () => {
        dispatch(getMemberDetails({ memberId: searchPatient.patientInformation.programSpecificPatientId, prgData: searchPatient.patientInformation.Program }))
        dispatch(setGetMemberLookupData(false))
    }

    searchPatient.getMemberLookupData && getMemberDataOfPatient();

    // Get Partner member data for the patient
    const getMemberDataFromPartner = () => {
        dispatch(getPatientMemberInPartner({ memberId: searchPatient.patientInformation.partnerPatientId, prgData: 'PARTNER', selectedProgram: searchPatient.patientInformation.Program }))
        dispatch(setGetPartnerMemberLookupData(false));
    }


    // After getting data from the respective data page moving the screen to prequal 
    searchPatient.getPartnerMemberLookupData && getMemberDataFromPartner();
    const moveScreenToPreQual = () => {
        if (searchPatient.IsPatientLocked == true) {
            toast.error(`Online applications cannot be completed for this Patient at this time. Please contact the program at ${searchPatient.dyNumber} for assistance.`)
        } else {
            navigate('/createApp/prequal')
            // Restricting the route
            dispatch(setConditionalRoute({
                isFlag: true,
                currentFlow: (searchPatient.patientInformation.Program == 'CPR' || searchPatient.patientInformation.Program == 'FAF') ? 'Application' : 'CASE',
            }))
            // set Program program specific lookup/dropdown values
            dispatch(setProgramSpecificLookUp(searchPatient.patientInformation.Program));
            dispatch(setRouteToPrescreen(false));
        }
    }

    searchPatient.routeToPrescreen && moveScreenToPreQual();

    const updatePortalUserMail = () => {
        if (updateEmail.email.value != '' && updateEmail.email.isValid) {
            let data = {
                newEmail: updateEmail.email.value,
                existingEmail: loginData.value.EmailAddress,
            }
            dispatch(
                updateEmailAPI({ email: data, portalID: loginData.value.PortalUserID })
            )
        } else {
            toast.error(errorMessage.mandatoryFieldsToastErrorMessage)
        }


    }

    // Patient Details
    return (
        <>{searchPatient.displayPatientCard && <>
            <div className="intro-y box px-5 pt-5 mt-5 py-5">
                <div className="d-flex flex-column flex-lg-row border-bottom border-gray-200 dark-border-dark-5 pb-5 mx-n5">
                    <div className="d-flex flex-1 px-5 align-items-center justify-content-center justify-content-lg-start">
                        <div className="ms-1">
                            <div className="w-24 w-sm-40 truncate white-space-sm-wrap fw-medium fs-lg"> {searchPatient.patientDetails.firstName} {searchPatient.patientDetails.lastName}</div>
                            {/* <div className="text-gray-600">CPR</div> */}
                        </div>
                    </div>
                    <div className="mt-6 mt-lg-0 flex-1 dark-text-gray-300 px-5 border-start border-end border-gray-200 dark-border-dark-5 border-top border-top-lg-0 pt-5 pt-lg-0">
                        <div className="fw-medium text-center text-lg-start mt-lg-3 px-2">{selectedLanguage.heading} </div>
                        <div className="d-flex flex-column justify-content-center align-items-center align-items-lg-start mt-4">
                            <div className="truncate white-space-sm-normal d-flex align-items-center"> <div className="text-gray-600 px-2">{selectedLanguage.contactID} </div>{searchPatient.patientDetails.patientId}</div>
                            <div className="truncate white-space-sm-normal d-flex align-items-center mt-3"><div className="text-gray-600 px-2">{searchPatient.patientDetails.isSSN ? selectedLanguage.SSN : selectedLanguage.AlienNumber}  </div>{searchPatient.patientDetails.isSSN ? maskData('SSN', searchPatient.patientDetails.ssn) : maskData('Alien', searchPatient.patientDetails.alienNumber)}</div>
                            <div className="truncate white-space-sm-normal d-flex align-items-center mt-3"> <div className="text-gray-600 px-2">{selectedLanguage.DOB} </div>{searchPatient.patientDetails.dob} </div>
                        </div>
                    </div>
                    <div className="mt-6 mt-lg-0 flex-1 dark-text-gray-300 px-5 border-start border-end border-gray-200 dark-border-dark-5 border-top border-top-lg-0 pt-5 pt-lg-0">
                        <div className="fw-medium text-center text-lg-start mt-lg-3">{selectedLanguage.contactDetails}</div>
                        <div className="d-flex flex-column justify-content-center align-items-center align-items-lg-start mt-4">
                            {searchPatient?.patientDetails?.email != "" && searchPatient?.patientDetails?.email != undefined && <div className="truncate white-space-sm-normal d-flex align-items-center"> <Mail className="w-4 h-4 me-2" />{searchPatient.patientDetails.email}</div>}
                            <div className="truncate white-space-sm-normal d-flex align-items-center mt-3"> <Phone className="w-4 h-4 me-2" />{searchPatient.patientDetails.phoneNumber} </div>
                            <div style={{ width: "100%" }} className="truncate white-space-sm-normal d-flex align-items-center mt-3"> <Home className="w-4 h-4 me-2" />{searchPatient.patientDetails.fullAddress}</div>
                        </div>
                    </div>
                </div>

                {/* Apply for service section */}
                {value && <div className="px-5 px-sm-20 mt-4 mb-10">
                    <div className="fw-medium fs-base mt-10">
                        <p className="p-1 ps-3 text-theme-1" > {selectedLanguage.applyforheading} </p>
                    </div>
                    <div className="grid columns-12 gap-4  px-6">
                        <div className="intro-y g-col-12 g-col-md-7 g-col-xl-7">
                            <Input
                                id="selectProgram"
                                name='program'
                                type="select"
                                elmentconfig={Object.keys(generalConfig).map((data) => typeof generalConfig[data].isAvailable != 'undefined' && generalConfig[data].isAvailable && { key: generalConfig[data].PROGRAM, value: generalConfig[data].programName })}
                                label={selectedLanguage.selectProgram}
                                value={selectProgram.program.value}
                                isValid={selectProgram.program.isValid}
                                errorMsg={errorMessage.inputErrorMessage}
                                onChange={(e) => inputOnChange(e, 'select')}
                            />
                        </div>
                        <div className="intro-y g-col-12 g-col-md-5 g-col-xl-5 py-4 px-5">
                            <button className="w-72 btn btn-yellow align-items-center" disabled={selectProgram.program.value == "CM" && patientCaseListData?.hasActiveCase} onClick={onCreateApp}>{selectProgram.program.value == "CM" ? selectedLanguage.createCase : selectedLanguage.createApp} </button>
                        </div>
                        <Modal
                            title=''
                            open={false}
                            // onCancel={() => setCancelFlowModal(false)}
                            // onOk={onClickCancelFlow}
                            okText={'Yes'}
                            cancelText={'No'}
                            maskClosable={false}
                            closable={false}
                        >
                            <span className='modal_style'> Stephen Rog currently has an active case. Do you want to view it? </span>
                        </Modal>
                    </div>
                    {(patientCaseListData?.hasActiveCase && selectProgram.program.value == "CM") && <div className="grid columns-12 gap-4 px-6">

                        <p className="color-danger g-col-12 text-start px-8">
                            {searchPatient.patientDetails.firstName.trim()} {searchPatient.patientDetails.lastName.trim()} currently has an active case.
                        </p>
                    </div>}
                </div>}

                </div>
            </>}
            <Modal
                title= {failureSFMsg != undefined ? failureSFMsg : ""}
                open={emailModal}
                onOk={() => { updatePortalUserMail() }}
                onCancel={() => {
                    setUpdateEmail({
                        email: {
                            value: loginData.Email,
                            isValid: true,
                        },
                    });
                    setEmailModal(false);
                }}
                width={800}
                cancelText="Cancel"
                maskClosable={true}
                closeIcon={false}
                okText="Save"
                centered
            >
                <div className="mb-5">
                    <ul>
                        {typeof allowedEmailDomains != "undefined" && allowedEmailDomains.length > 0 && allowedEmailDomains.map((data) => {
                            return (
                                <li className="list-disc ms-5"> {data} </li>
                            )
                        })}
                    </ul>
                </div>
                <Input
                    id="email"
                    type="text"
                    name="email"
                    label={createPatientLanguage.email}
                    value={updateEmail.email.value}
                    isValid={updateEmail.email.isValid}
                    errorMsg={errorMessage.inputErrorMessage}
                    onChange={(e) => emailOnChange(e, "email")}
                    maxLength="100"
                />
            </Modal>
        </>
    )
}

export default PatientDetails